import React, { useEffect, useState } from 'react'
import { Col, Row } from 'reactstrap'
import { useHistory } from 'react-router-dom';
import { notify, triggerFileDownloadByUrl, userDetails } from '../../../../../../../helper';
import LoaderCustom from '../../../../../../common/LoaderCustom';
import axiosHelper from '../../../../../../../axiosHelper';
import { API } from '../../../../../../../config/constants';
import PopupMsgWrapper from '../../../../../../common/PopupMsgWrapper';

let loggedInUserDetail = userDetails();

function BankDetailsView(props) {
    const history = useHistory()

    let bankDetails = props.supplierDetail?.Data?.BankDetails;
    let supplierData = props.supplierDetail?.Data;

    const [showTabLoader, setShowTabLoader] = useState(true);
    const [showPopup, setShowPopup] = useState(false);
    const [isApproveKys1PopupOpen, setIsApproveKys1PopupOpen] = useState(false);
    const [isRequestReviewRemarkPopupOpen, setIsRequestReviewRemarkPopupOpen] = useState(false);
    const [requestReviewRemark, setRequestReviewRemark] = useState("");
    const [bankDetailsToSubmit, setBankDetailsToSubmit] = useState(null)
    const [vendorRequirementRegistrationId, setVendorRequirementRegistrationId] = useState(0)

    const hidePageLoader = () => setTimeout(() => {
        setShowTabLoader(false);
    }, 2000);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const id = urlParams.get("VendorRequirementRegistrationId");
        if (id) {
            setVendorRequirementRegistrationId(id);
        }
    }, []);

    useEffect(() => {
        if (props.supplierDetail?.IsSuccessful) {
            setShowTabLoader(false);
        }
    }, [props.supplierDetail?.IsSuccessful])

    const onPopupConfirmSubmit = () => {
        // Handle confirmation logic if needed
        // setShowPopup(false);
        // if (bankDetailsToSubmit) {
        //     axiosHelper.post(`${API.addAndUpdateKYS1BankDetail}`, bankDetailsToSubmit)
        //         .then((response) => {
        //             if (response.data.IsSuccessful) {
        //                 notify.success(response?.data?.Data?.Message)
        //                 hidePageLoader()
        //             }
        //         })
        //         .catch((error) => {
        //             // hidePageLoader();
        //             if (!error?.response?.data?.IsSuccessful) {
        //                 notify.error(error?.response?.data?.ErrorMessage)
        //             }
        //         });
        // }
    };

    const reviewRequestOrApproveKYS1Form = (reqType) => {
        // reqType will be => Approved or ReviewRequested
        // requestReviewRemark
        let payload = {
            "VendorRequirementRegistrationId": vendorRequirementRegistrationId,
            "ActionTakenBy": loggedInUserDetail?.EmployeeId,
            "Action": reqType
        }
        if (reqType === "ReviewRequested") {
            payload.Remark = requestReviewRemark;
            setIsRequestReviewRemarkPopupOpen(false)
        }
        if (reqType === "Approved") {
            setIsApproveKys1PopupOpen(false)
        }
        setShowTabLoader(true);
        axiosHelper.post(`${API.reviewRequestApproveKYS1Form}`, payload)
            .then((response) => {
                if (response.data.IsSuccessful) {
                    notify.success(response?.data?.Data?.Message)
                    hidePageLoader()
                    if (props?.viewDataFromSupplier?.IsBlockedVendor) {
                        history.push("/supplier-unblocking-request");
                      } else {
                        history.push("/vendor-need-list");
                      }
                }
            })
            .catch((error) => {
                // hidePageLoader();
                if (!error?.response?.data?.IsSuccessful) {
                    notify.error(error?.response?.data?.ErrorMessage);
                }
            });
    }


    return (
        <>
            {showTabLoader && (<LoaderCustom customClass="simulation-Loader hl-loader-fixed" />)}
            <Row>
                <Col xs={12} md={6}>
                    <Row>
                        <Col span={12} md={12} xl={12}>
                            <h3 className="sd-common-heading">Bank Details of Supplier</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Bank Account Number</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.BankAccountNumber || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Bank Name</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.BankName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Bank Branch</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.BankBranch || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">RTGS/NEFT/IFSC Code</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.RTGSCode || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Address</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.Address || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">City</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.City || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Country</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.VendorBankDetails?.CountryName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Payment Currency</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.GeneralDetailsOfVendor?.PaymentCurrencyName || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">
                                {
                                    supplierData?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 1 && (
                                        <>
                                            Cancelled cheque
                                        </>
                                    )
                                }
                                {
                                    supplierData?.KYS1ContactDetails?.RegistrationDetail?.DomesticandOverseas === 2 && (
                                        <>
                                            Duly signed & stamp letter of declaration/PI for bank detail
                                        </>
                                    )
                                }
                            </span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details hl-multi-val">
                                <span className="w-50">{bankDetails?.VendorBankDetails?.CancelledChequeDocumentName || '-'}</span>
                                {
                                    bankDetails?.VendorBankDetails?.CancelledChequeDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, bankDetails?.VendorBankDetails?.CancelledChequeDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>
                    </Row>
                    <Row className='mt-4'>
                        <Col span={12} md={12}>
                            <h3 className="sd-common-heading">General Details of Supplier</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Consolidated Last Year Turnover</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details hl-multi-val">
                                {
                                    !bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY && !bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYTypeName ? (
                                        <span>-</span>
                                    ) : (
                                        <>
                                            <span>{bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY || '-'}</span>
                                            <span>{bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYTypeName || '-'}</span>
                                        </>
                                    )
                                }
                                {
                                    bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYDocument && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLYDocument)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Consolidated Last Year Turnover (Y-1)</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details hl-multi-val">
                                {
                                    !bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1 && !bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1TypeName ? (
                                        <span>-</span>
                                    ) : (
                                        <>
                                            <span>{bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1 || '-'}</span>
                                            <span>{bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1TypeName || '-'}</span>
                                        </>
                                    )
                                }
                                {
                                    bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1Document && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_1Document)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Consolidated Last Year Turnover (Y-2)</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-0 hl-descmain-details">
                            <span className="hl-desc-details hl-multi-val">
                                {
                                    bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2 || bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2TypeName ? (
                                        <>
                                            <span>{bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2 || '-'}</span>
                                            <span>{bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2TypeName || '-'}</span>
                                        </>
                                    ) : (
                                        <span>-</span>
                                    )
                                }
                                {
                                    bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2Document && (
                                        <button
                                            className={`btn btn-secondary hl-download-btn hl-upload-btn ms-auto hl-mb-0`}
                                            onClick={(e) => triggerFileDownloadByUrl(e, bankDetails?.GeneralDetailsOfVendor?.ConsolidatedRevenueLY_2Document)}
                                            title="Download"
                                        >
                                            <div className="download mr-0"></div>
                                        </button>
                                    )
                                }
                            </span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Whether E-Invoice Enabled Supplier</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.GeneralDetailsOfVendor?.Invoiceeligibility ? 'Yes' : 'No'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Main Customers</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details hl-text-preline">{bankDetails?.GeneralDetailsOfVendor?.MainCustomers || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Main Product/Services</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details hl-text-preline">{bankDetails?.GeneralDetailsOfVendor?.MainProduct || '-'}</span>
                        </Col>
                    </Row>
                </Col>
                <Col xs={12} md={6}>
                    <Row>
                        <Col span={12} md={12}>
                            <h3 className="sd-common-heading">Authorised Signatory</h3>
                        </Col>
                    </Row>
                    <Row className="hl-detail-column m-0">
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Name</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.GeneralDetailsOfVendor?.AuthorisedSignatory_Name || '-'}</span>
                        </Col>

                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Designation</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.GeneralDetailsOfVendor?.AuthorisedSignatory_Designation || '-'}</span>
                        </Col>
                        {/* 
                        <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">I hereby declare that all the information given by me in this application is true and correct to the best of my knowledge and belief</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details text-uppercase">{bankDetails?.GeneralDetailsOfVendor?.Declartion ? 'Yes' : 'No'}</span>
                        </Col> */}

                        {/* <Col xs={12} md={6} className="hl-heading-details">
                            <span className="hl-title-details">Supplying to which plants of Havells</span>
                        </Col>
                        <Col xs={12} md={6} className="pr-6 hl-descmain-details">
                            <span className="hl-desc-details">{bankDetails?.GeneralDetailsOfVendor?.SupplyingPlantName || '-'}</span>
                        </Col> */}
                    </Row>
                </Col>
            </Row>
            <Row className="justify-content-between sf-btn-footer no-gutters justify-content-between bottom-footer sticky-btn-footer mt-3">
                <div className="col-sm-12 text-right bluefooter-butn">
                    {!supplierData?.IsKYS1FormApproved && supplierData?.KYS1Level1ApproverList?.includes(parseInt(loggedInUserDetail?.EmployeeId)) && (
                        <>

                            <button type="button" className="submit-button save-btn mr-2" onClick={() => setIsApproveKys1PopupOpen(true)}>
                                {"Approve KYS 1"}
                            </button>
                            <button type="button" className="submit-button save-btn mr-2" onClick={() => setIsRequestReviewRemarkPopupOpen(true)}>
                                {"Request Review"}
                            </button>
                        </>
                    )}
                </div>
            </Row>
            <PopupMsgWrapper
                firstButtonName="Proceed"
                secondButtonName="Cancel"
                header=""
                isOpen={showPopup}
                closePopUp={() => setShowPopup(false)}
                confirmPopup={onPopupConfirmSubmit}
                message={
                    <>
                        Do you really want to proceed?
                    </>
                }
                iconClass="d-none"
                imgClass="hl-img-confirmation"
                popupWrapper="popup-wrapper-main"

            />
            <PopupMsgWrapper
                firstButtonName="Proceed"
                secondButtonName="Cancel"
                header=""
                isOpen={isApproveKys1PopupOpen}
                closePopUp={() => setIsApproveKys1PopupOpen(false)}
                confirmPopup={() => reviewRequestOrApproveKYS1Form("Approved")}
                message={
                    <>
                        Approve KYS1 request?
                    </>
                }
                iconClass="d-none"
                imgClass="hl-img-confirmation"
                popupWrapper="popup-wrapper-main"

            />
            {
                isRequestReviewRemarkPopupOpen && (
                    <PopupMsgWrapper
                        firstButtonName="Submit"
                        secondButtonName="Cancel"
                        header=""
                        isOpen={isRequestReviewRemarkPopupOpen}
                        isInputField={true}
                        setInputData={(data) => {
                            setRequestReviewRemark(data);
                        }}
                        closePopUp={() => {
                            setIsRequestReviewRemarkPopupOpen(false)
                            setRequestReviewRemark("")
                        }}
                        // confirmPopup={() => reviewRequestOrApproveKYS1Form("ReviewRequested")}
                        confirmPopup={() => {
                            if (!requestReviewRemark) {
                                setIsRequestReviewRemarkPopupOpen(true);
                            } else {
                                reviewRequestOrApproveKYS1Form("ReviewRequested")
                            }
                        }}
                        iconClass="d-none"
                        imgClass="hl-img-confirmation"
                        popupWrapper="popup-wrapper-main"

                    />
                )
            }
        </>
    )
}

export default BankDetailsView